import { GenericalRecord } from '../../../../types/utilities'
import { UseStore } from '../../../../types/zustand'
import { useContextStore, useContextStoreApi } from '../../../../utils/zustand'
import { RemoteTransferStoreContext } from '../contexts/StoreContext'
import { RemoteTransferStore } from '../store/interface'

export const useRemoteTransferStore: UseStore<
  RemoteTransferStore<GenericalRecord, GenericalRecord>
> = selector => {
  return useContextStore(RemoteTransferStoreContext, selector)
}

export const useRemoteTransferStoreApi = () => {
  return useContextStoreApi(RemoteTransferStoreContext)
}
